import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-layout',
  template: '<router-outlet />',
  styleUrl: './blank-layout.component.scss'
})
export class BlankLayoutComponent {
  

}
